// extracted by mini-css-extract-plugin
export default {"container":"styles_container__x8uZu","title":"styles_title__bb-vu","from":"styles_from__pjJVq","img":"styles_img__PO4jv"};